module.exports = __webpack_public_path__ + "img/bottlesClose_thumb.a3d4b29d.jpg";